import { Project, Market } from "../../classes"
import moment from "moment";
import Helper from "../../plugins/Helper/Helper";

const OverallModule = {
  namespaced: true,
  state: {
    projectId: null,
    markets: null, // Type Object
    areas: null, // Type Object
    products: null, // Type Object
    productCategorys: null, // Type Object
    accountingProducts: null, // Type Object
    contracts: null,
    areaBookings: null,
    invoices: null,
    isLoadingArea: false,
    isLoadingProduct: false,
    isLoadingProductCategory: false,
    isLoadingMarket: false,
    isLoadingAccountingProduct: false
  },
  mutations: {
    // let [markets, areas, contracts, areaBookings, invoices] = await Promise.all(promises)
    setProjectId(state, projectId) {
      state.projectId = projectId
    },
    setMarkets(state, markets) {
      state.markets = markets
    },
    setAreas(state, areas) {
      state.areas = areas
    },
    setProducts(state, products) {
      state.products = products
    },
    setProductCategorys(state, productCategorys) {
      state.productCategorys = productCategorys
    },
    setAccountingProducts(state, accountingProducts) {
      state.accountingProducts = accountingProducts
    },
    setContracts(state, contracts) {
      state.contracts = contracts
    },
    setAreaBookings(state, areaBookings) {
      state.areaBookings = areaBookings
    },
    setInvoices(state, invoices) {
      state.invoices = invoices
    },
    setIsLoadingArea(state, isLoadingArea) {
      state.isLoadingArea = isLoadingArea
    },
    setIsLoadingProduct(state, isLoadingProduct) {
      state.isLoadingProduct = isLoadingProduct
    },
    setIsLoadingProductCategory(state, isLoadingProductCategory) {
      state.isLoadingProductCategory = isLoadingProductCategory
    },
    setIsLoadingMarket(state, isLoadingMarket) {
      state.isLoadingMarket = isLoadingMarket
    },
    setIsLoadingAccountingProduct(state, isLoadingAccountingProduct) {
      state.isLoadingAccountingProduct = isLoadingAccountingProduct
    }
  },
  actions: {
    getProjectOverAllAreaData: async ({ commit, state }, payload) => {
      try {
        if (state.areas && state.areas.projectId == payload.projectId) {
          return state.areas.data
        } else {
          if (state.isLoadingArea) {
            return new Promise((resolve) => {
              const checkData = () => {
                if (!state.isLoadingArea) {
                  resolve(state.areas.data);
                } else {
                  setTimeout(checkData, 100);
                }
              };
              checkData();
            });
          } else {
            commit("setIsLoadingArea", true);
            commit("setAreas", null);
            let data = await Project.getProjectOverAllAreaData(payload)
            commit("setAreas", { data: data, projectId: payload.projectId });
            commit("setIsLoadingArea", false);
            return data
          }
        }
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllProductData: async ({ commit, state }, payload) => {
      try {
        if (state.products && state.products.projectId == payload.projectId) {
          return state.products.data
        } else {
          if (state.isLoadingProduct) {
            return new Promise((resolve) => {
              const checkData = () => {
                if (!state.isLoadingProduct) {
                  resolve(state.products.data);
                } else {
                  setTimeout(checkData, 100);
                }
              };
              checkData();
            });
          } else {
            commit("setIsLoadingProduct", true);
            commit("setProducts", null);
            let data = await Project.getProjectOverAllProductData(payload)
            commit("setProducts", { data: data, projectId: payload.projectId });
            commit("setIsLoadingProduct", false);
            return data
          }
        }
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllProductCategoryData: async ({ commit, state }, payload) => {
      try {
        if (state.productCategorys && state.productCategorys.projectId == payload.projectId) {
          return state.productCategorys.data
        } else {
          if (state.isLoadingProductCategory) {
            return new Promise((resolve) => {
              const checkData = () => {
                if (!state.isLoadingProductCategory) {
                  resolve(state.productCategorys.data);
                } else {
                  setTimeout(checkData, 100);
                }
              };
              checkData();
            });
          } else {
            commit("setIsLoadingProductCategory", true);
            commit("setProductCategorys", null);
            let data = await Project.getProjectOverAllProductCategoryData(payload)
            commit("setProductCategorys", { data: data, projectId: payload.projectId });
            commit("setIsLoadingProductCategory", false);
            return data
          }
        }
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllMarketData: async ({ commit, state }, payload) => {
      try {
        if (state.markets && state.markets.projectId == payload.projectId) {
          return state.markets.data
        } else {
          if (state.isLoadingMarket) {
            return new Promise((resolve) => {
              const checkData = () => {
                if (!state.isLoadingMarket) {
                  resolve(state.markets.data);
                } else {
                  setTimeout(checkData, 100);
                }
              };
              checkData();
            });
          } else {
            commit("setIsLoadingMarket", true);
            commit("setMarkets", null);
            let data = await Market.getMarketByProject(payload.projectId)
            commit("setMarkets", { data: data, projectId: payload.projectId });
            commit("setIsLoadingMarket", false);
            return data
          }
        }
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllAccountingProductData: async ({ commit, state }, payload) => {
      try {
        if (state.accountingProducts && state.accountingProducts.projectId == payload.projectId) {
          return state.accountingProducts.data
        } else {
          if (state.isLoadingAccountingProduct) {
            return new Promise((resolve) => {
              const checkData = () => {
                if (!state.isLoadingAccountingProduct) {
                  resolve(state.accountingProducts.data);
                } else {
                  setTimeout(checkData, 100);
                }
              };
              checkData();
            });
          } else {    
            commit("setIsLoadingAccountingProduct", true);
            commit("setAccountingProducts", null);
            let data = await Project.getProjectOverAllAccountingProductData(payload)
            commit("setAccountingProducts", { data: data, projectId: payload.projectId });
            commit("setIsLoadingAccountingProduct", false);
            return data
          }
        }
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllAreaProductData: async ({ commit, state, dispatch }, payload) => {
      try {
        let [areas, products, productCategorys] = await Promise.all([
          dispatch("getProjectOverAllAreaData", payload),
          dispatch("getProjectOverAllProductData", payload),
          dispatch("getProjectOverAllProductCategoryData", payload),
        ])
        let hashProduct = {}
        let hashProductCategory = {}
        for (let productCategory of productCategorys) {
          hashProductCategory[productCategory.objectId] = productCategory
        }
        for (let product of products) {
          if (product.productCategory && hashProductCategory[product.productCategory.objectId])
            product.productCategory = hashProductCategory[product.productCategory.objectId]
          hashProduct[product.objectId] = product
        }
        for (let area of areas) {
          for (let key in area.products) {
            if(area.products[key]){
              if (hashProduct[area.products[key].objectId]) {
                area.products[key] = hashProduct[area.products[key].objectId]
              }
            }
          }
        }
        return areas
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllContractData: async ({ commit, state }, payload) => {
      try {
        commit("setContracts", null);
        let data = await Project.getProjectOverAllContractData(payload)
        commit("setContracts", data);
        return data
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllAreaBookingData: async ({ commit, state }, payload) => {
      try {
        commit("setAreaBookings", null);
        let data = await Project.getProjectOverAllAreaBookingData(payload)
        commit("setAreaBookings", data);
        return data
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllInvoiceData: async ({ commit, state }, payload) => {
      try {
        commit("setInvoices", null);
        let data = await Project.getProjectOverAllInvoiceData(payload)
        commit("setInvoices", data);
        return data
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllWithPreviousData: async ({ commit, dispatch }, payload) => {
      try {
        let previousPaylead = { 
          ...payload,
          startDate: moment(payload.startDate).subtract(1, "years").toDate(),
          endDate: moment(payload.endDate).subtract(1, "years").toDate(),
          
        }
        let promises = [
          dispatch("getProjectOverAllData", payload),
          dispatch("getProjectOverAllData", previousPaylead),
        ]
        let [ data, previousData ] = await Promise.all(promises)
        return { 
          ...data,
          previousData: previousData
        }
      } catch (error) {
        throw error
      }
    },
    getProjectOverAllData: async ({ commit, dispatch }, payload) => {
      try {
        let [ accountingProducts, markets, areas, contracts, areaBookings, invoices ] = await Promise.all([
          dispatch("getProjectOverAllAccountingProductData", payload),
          dispatch("getProjectOverAllMarketData", payload),
          dispatch("getProjectOverAllAreaProductData", payload),
          dispatch("getProjectOverAllContractData", payload),
          dispatch("getProjectOverAllAreaBookingData", payload),
          dispatch("getProjectOverAllInvoiceData", payload),
        ])
        let days = Helper.diffDays({ iso: payload.startDate }, { iso: payload.endDate })
        let hasArea = {}
        let maxTotalValue = 0
        let maxTotalValueMulSize = 0
        let hashMaxTotalValue = {}
        let hashMaxTotalValueMulSize = {}
        let hashAreaDate = {}
        let hashContractDate = {}
        let hashAreaBookingDate = {}
        let hashInvoiceDate = {}
        let hashOccupiedArea = {}
        let hashAccountingProduct = {}
        let hashMonth = {}
        let hashCustomer = {}

        function setOccupiedArea(key, areas) {
          if (!hashOccupiedArea[key]) hashOccupiedArea[key] = {}
          for (let area of areas) {
            hashOccupiedArea[key][area.objectId] = true
          }
        }
        for (let accountingProduct of accountingProducts) {
          if (!hashAccountingProduct[accountingProduct.objectId]) hashAccountingProduct[accountingProduct.objectId] = accountingProduct
        }

        let mmm = moment(payload.startDate).subtract(1, "days").startOf("month")
        do {
          let mmTh = moment(mmm)
          hashMonth[mmTh.format("YYYY-MM")] = {
            totalValue: 0
          }
          mmm.add(1, "months")
        } while (mmm < moment(payload.endDate).endOf("month"));
        
        for (let contract of contracts) {
          let mm = moment(payload.startDate)
          do {
            let mmStart = moment(mm)
            let mmEnd = moment(mm).endOf("day")
            let key = contract && contract.market && contract.market.objectId ? contract.market.objectId + "-" + mmStart.format("YYYY-MM-DD") : ""
            if (!hashContractDate[key]) hashContractDate[key] = []
            if (contract.isActive && moment(contract.startDate.iso) <= mmEnd) {
              hashContractDate[key].push(contract)
              setOccupiedArea(key, contract.areas)
            } else if (contract.closeContractAt) {
              if (moment(contract.closeContractAt.iso) >= mmStart && moment(contract.startDate.iso) <= mmEnd) {
                hashContractDate[key].push(contract)
                setOccupiedArea(key, contract.areas)
              }
            } else {
              if (moment(contract.endDate.iso) >= mmStart && moment(contract.startDate.iso) <= mmEnd) {
                hashContractDate[key].push(contract)
                setOccupiedArea(key, contract.areas)
              }
            }
            mm.add(1, "days")
          } while (mm < moment(payload.endDate));
        }
        
        for (let areaBooking of areaBookings) {
          let mm = moment(payload.startDate)
          do {
            let mmStart = moment(mm)
            let mmEnd = moment(mm).endOf("day")
            let key = areaBooking.market.objectId + "-" + mmStart.format("YYYY-MM-DD")
            if (!hashAreaBookingDate[key]) hashAreaBookingDate[key] = []
            if (!areaBooking.checkedOutDate && moment(areaBooking.checkedInDate.iso) <= mmEnd) {
              hashAreaBookingDate[key].push(areaBooking)
              setOccupiedArea(key, [areaBooking.area])
            } else if (areaBooking.checkedOutDate) {
              if (moment(areaBooking.checkedOutDate.iso) >= mmStart && moment(areaBooking.checkedInDate.iso) <= mmEnd) {
                hashAreaBookingDate[key].push(areaBooking)
                setOccupiedArea(key, [areaBooking.area])
              }
            }
            mm.add(1, "days")
          } while (mm < moment(payload.endDate));
        }
        
        let productData = {
          hashMarket: {},
          hashAll: {},
        }
        
        for (let area of areas) {
          let market = area.market
          if (!hasArea[area.objectId]) {
            hasArea[area.objectId] = {
              obj: area,
              size: area.size || 0,
              marketId: area.market.objectId,
              days: 0,
              occupiedDays: 0,
              totalValue: 0,
              totalValueMulSize: 0,
            }
          }
          let mm = moment(payload.startDate)
          do {
            let mmStart = moment(mm)
            let mmEnd = moment(mm).endOf("day")
            let key = area.market.objectId + "-" + mmStart.format("YYYY-MM-DD")
            if (!hashAreaDate[key]) hashAreaDate[key] = {}
            if (area.isRemoved) {
              let removedAt = area.removedAt ? area.removedAt.iso : area.updatedAt
              if (moment(area.createdAt) <= mmEnd && moment(removedAt) >= mmStart) {
                hashAreaDate[key][area.objectId] = area
              }
            } else {
              if (moment(area.createdAt) <= mmEnd) {
                hashAreaDate[key][area.objectId] = area
              }
            }
      
            hasArea[area.objectId].days += 1
            if (hashOccupiedArea[key] && hashOccupiedArea[key][area.objectId]) {
              hasArea[area.objectId].occupiedDays += 1
            }

            mm.add(1, "days")
          } while (mm < moment(payload.endDate));

          if (!productData.hashMarket[market.objectId]) productData.hashMarket[market.objectId] = {}
          if(area.products){
            for (let product of area.products) {
              if (product.productCategory && product.productCategory.objectId) {
                let productCategoryId = product.productCategory?.objectId
                if (!productData.hashMarket[market.objectId][productCategoryId]) {
                  productData.hashMarket[market.objectId][productCategoryId] = {
                    productCategory: product.productCategory,
                    products: {},
                    areas: [],
                  }
                }
                if (!productData.hashMarket[market.objectId][productCategoryId].products[product.objectId]) {
                  productData.hashMarket[market.objectId][productCategoryId].products[product.objectId] = {
                    product: product,
                    count: 0
                  }
                }
                productData.hashMarket[market.objectId][productCategoryId].products[product.objectId].count += 1
                if (!productData.hashMarket[market.objectId][productCategoryId].areas.find(d => d == area.objectId)) {
                  productData.hashMarket[market.objectId][productCategoryId].areas.push(area.objectId)
                }
        
                if (!productData.hashAll[productCategoryId]) {
                  productData.hashAll[productCategoryId] = {
                    productCategory: product.productCategory,
                    products: {},
                    areas: []
                  }
                }
                if (!productData.hashAll[productCategoryId].products[product.objectId]) {
                  productData.hashAll[productCategoryId].products[product.objectId] = {
                    product: product,
                    count: 0
                  }
                }
                productData.hashAll[productCategoryId].products[product.objectId].count += 1
                if (!productData.hashAll[productCategoryId].areas.find(d => d == area.objectId)) {
                  productData.hashAll[productCategoryId].areas.push(area.objectId)
                }
              }
            }
          }
        }

        let accData = {
          hashMarket: {},
          hashAll: {},
        }

        for (let invoice of invoices) {
          let key = invoice.market.objectId + "-" + moment(invoice.date).format("YYYY-MM-DD")
          let monthYear = moment(invoice.date).format("YYYY-MM")
          let market = invoice.market
          let customerData = invoice.customerData
          if (!hashInvoiceDate[key]) hashInvoiceDate[key] = []
          hashInvoiceDate[key].push(invoice)
          for (let item of invoice.items || []) {
            if (item.area) {
              let _area = item.area
              if (hasArea[_area.objectId]) {
                let areaMarketId = hasArea[_area.objectId].marketId
                hasArea[_area.objectId].totalValue += item.totalValue
                hasArea[_area.objectId].totalValueMulSize += (item.totalValue / hasArea[_area.objectId].size)

                if (hasArea[_area.objectId].totalValue > maxTotalValue) {
                  maxTotalValue = hasArea[_area.objectId].totalValue
                }
                if (hasArea[_area.objectId].totalValueMulSize > maxTotalValueMulSize) {
                  maxTotalValueMulSize = hasArea[_area.objectId].totalValueMulSize
                }

                if (!hashMaxTotalValue[areaMarketId]) hashMaxTotalValue[areaMarketId] = 0
                if (!hashMaxTotalValueMulSize[areaMarketId]) hashMaxTotalValueMulSize[areaMarketId] = 0

                if (hasArea[_area.objectId].totalValue > hashMaxTotalValue[areaMarketId]) {
                  hashMaxTotalValue[areaMarketId] = hasArea[_area.objectId].totalValue
                }
                
                if (hasArea[_area.objectId].totalValueMulSize > hashMaxTotalValueMulSize[areaMarketId]) {
                  hashMaxTotalValueMulSize[areaMarketId] = hasArea[_area.objectId].totalValueMulSize
                }
              }
            }
            
            if (item.accountingProduct && item.accountingProduct.objectId) {
              let accountingProduct = hashAccountingProduct[item.accountingProduct.objectId]
              let type = accountingProduct ? accountingProduct.type : null
              if (type) {
                if (!accData.hashMarket[market.objectId]) accData.hashMarket[market.objectId] = {}
                  if (!accData.hashMarket[market.objectId][type]) {
                    accData.hashMarket[market.objectId][type] = {
                      accountingProducts: {},
                      totalValue: 0
                    }
                  }
                  if (!accData.hashMarket[market.objectId][type].accountingProducts[accountingProduct.objectId]) {
                    accData.hashMarket[market.objectId][type].accountingProducts[accountingProduct.objectId] = {
                      accountingProduct: accountingProduct,
                      totalValue: 0
                    }
                  }
                  accData.hashMarket[market.objectId][type].totalValue += item.totalValue
                  accData.hashMarket[market.objectId][type].accountingProducts[accountingProduct.objectId].totalValue += item.totalValue
          
                  if (!accData.hashAll[type]) {
                    accData.hashAll[type] = {
                      accountingProducts: {},
                      totalValue: 0
                    }
                  }
                  if (!accData.hashAll[type].accountingProducts[accountingProduct.objectId]) {
                    accData.hashAll[type].accountingProducts[accountingProduct.objectId] = {
                      accountingProduct: accountingProduct,
                      totalValue: 0
                    }
                  }
                  accData.hashAll[type].totalValue += item.totalValue
                  accData.hashAll[type].accountingProducts[accountingProduct.objectId].totalValue += item.totalValue  
              }
            }
          }
          if (customerData && customerData.name) {
            if (!hashCustomer[customerData.name]) {
              hashCustomer[customerData.name] = {
                totalValue: 0,
                data: JSON.parse(JSON.stringify(hashMonth)),
              }
            }
            hashCustomer[customerData.name].totalValue += invoice.totalValue;
            if (hashCustomer[customerData.name]["data"][monthYear]) {
              hashCustomer[customerData.name]["data"][monthYear].totalValue += invoice.totalValue;
            }
          }
        }
        let lastValue = 0
        let lastIndex = 1

        let entries = Object.entries(hasArea);
        entries.sort((a, b) => b[1].totalValue - a[1].totalValue);
        entries.forEach((entry, index) => {
          if (lastValue != hasArea[entry[0]].totalValue) {
            lastValue = hasArea[entry[0]].totalValue
            lastIndex = index + 1
            hasArea[entry[0]].totalValueRankInProject = lastIndex
          } else {
            hasArea[entry[0]].totalValueRankInProject = lastIndex
          }
        });

        lastValue = 0
        lastIndex = 1
        entries.sort((a, b) => b[1].occupiedDays - a[1].occupiedDays);
        entries.forEach((entry, index) => {
          if (lastValue != hasArea[entry[0]].occupiedDays) {
            lastValue = hasArea[entry[0]].occupiedDays
            lastIndex = index + 1
            hasArea[entry[0]].occupiedDaysRankInProject = lastIndex
          } else {
            hasArea[entry[0]].occupiedDaysRankInProject = lastIndex
          }
        });
        
        for (let key in hasArea) {
          hasArea[key].occupiedPercent = (hasArea[key].occupiedDays / hasArea[key].days) * 100
          hasArea[key].totalValuePercent = ((hasArea[key].totalValue / maxTotalValue) * 100) || 0
          hasArea[key].totalValueMulSizePercent = ((hasArea[key].totalValueMulSize / maxTotalValueMulSize) * 100) || 0
          hasArea[key].totalValuePercentInMarket = ((hasArea[key].totalValue / hashMaxTotalValue[hasArea[key].marketId]) * 100) || 0
          hasArea[key].totalValueMulSizePercentInMarket = ((hasArea[key].totalValueMulSize / hashMaxTotalValueMulSize[hasArea[key].marketId]) * 100) || 0
        }
    
        let hashAreaMarket = {}
        for (let key in hasArea) {
          if (!hashAreaMarket[hasArea[key].marketId]) hashAreaMarket[hasArea[key].marketId] = {}
          hashAreaMarket[hasArea[key].marketId][key] = hasArea[key]
        }
    
        for (let marketId in hashAreaMarket) {
          lastValue = 0
          lastIndex = 1

          let entriesMarket = Object.entries(hashAreaMarket[marketId]);
          entriesMarket.sort((a, b) => b[1].totalValue - a[1].totalValue);
          entriesMarket.forEach((entry, index) => {
            if (lastValue != hashAreaMarket[marketId][entry[0]].totalValue) {
              lastValue = hashAreaMarket[marketId][entry[0]].totalValue
              lastIndex = index + 1
              hashAreaMarket[marketId][entry[0]].totalValueRankInMarket = lastIndex
            } else {
              hashAreaMarket[marketId][entry[0]].totalValueRankInMarket = lastIndex
            }
          });

          lastValue = 0
          lastIndex = 1
          entriesMarket.sort((a, b) => b[1].occupiedDays - a[1].occupiedDays);
          entriesMarket.forEach((entry, index) => {
            if (lastValue != hashAreaMarket[marketId][entry[0]].occupiedDays) {
              lastValue = hashAreaMarket[marketId][entry[0]].occupiedDays
              lastIndex = index + 1
              hashAreaMarket[marketId][entry[0]].occupiedDaysRankInMarket = lastIndex 
            } else {
              hashAreaMarket[marketId][entry[0]].occupiedDaysRankInMarket = lastIndex
            }
          });
        }

        let hashMarket = {}
        for (let market of markets) {
          let hashDay = {}
          let hashMonth = {}
          let mm = moment(payload.startDate)
          do {
            let mmStart = moment(mm)
            let mmEnd = moment(mm).endOf("day")
            let hashkey = market.objectId + "-" + mmStart.format("YYYY-MM-DD")
            let allArea = hashAreaDate[hashkey] || {}
            let allContract = hashContractDate[hashkey] || []
            let allAreaBooking = hashAreaBookingDate[hashkey] || []
            let allInvoice = hashInvoiceDate[hashkey] || []
        
            let occupiedAreas = {}
            for (let contract of allContract) {
              for (let area of contract.areas) {
                if (allArea[area.objectId] && hasArea[area.objectId]) occupiedAreas[area.objectId] = hasArea[area.objectId].obj
              }
            }
        
            for (let areaBooking of allAreaBooking) {
              if (allArea[areaBooking.area.objectId] && hasArea[areaBooking.area.objectId]) occupiedAreas[areaBooking.area.objectId] = hasArea[areaBooking.area.objectId].obj
            }
            
            let allAreaArray = Object.entries(allArea).map(([key, value]) => value)
            let occupiedAreaArray = Object.entries(occupiedAreas).map(([key, value]) => value)
            let areaCount = allAreaArray.length
            let areaSizeCount = allAreaArray.reduce((a, b) => a + b.size, 0)
            let areaOccupied = occupiedAreaArray.length
            let areaSizeOccupied = occupiedAreaArray.reduce((a, b) => a + b.size, 0)

            if (mmEnd < moment().add(1, "days")) {
              hashDay[mmEnd.format("YYYY-MM-DD")] = {
                mmStart: mmStart.toDate(),
                mmEnd: mmEnd.toDate(),
                areaCount: areaCount,
                areaOccupied: areaOccupied,
                areaSizeCount: areaSizeCount,
                areaSizeOccupied: areaSizeOccupied,
                totalValue: allInvoice ? allInvoice.reduce((a, b) => a + b.totalValue, 0) : 0
              }
            } else {
              hashDay[mmEnd.format("YYYY-MM-DD")] = {
                isOutOfDate: true,
                areaCount: areaCount,
                areaOccupied: 0,
                areaSizeCount: areaSizeCount,
                areaSizeOccupied: 0,
                totalValue: 0
              }
            }
            mm.add(1, "days")
          } while (mm < moment(payload.endDate));
    
          for (let key in hashDay) {
            let data = hashDay[key]
            let monthYear = moment(key).format("YYYY-MM")
            if (!hashMonth[monthYear]) {
              hashMonth[monthYear] = {
                areaCount: [],
                areaOccupied: [],
                areaSizeCount: [],
                areaSizeOccupied: [],
                totalValue: 0,
                totalValueAvgSize: 0,
                totalValueAvgCount: 0
              }
            }
            hashMonth[monthYear].areaCount.push(data.areaCount)
            hashMonth[monthYear].areaOccupied.push(data.areaOccupied)
            hashMonth[monthYear].areaSizeCount.push(data.areaSizeCount)
            hashMonth[monthYear].areaSizeOccupied.push(data.areaSizeOccupied)
            hashMonth[monthYear].totalValue += data.totalValue
            hashMonth[monthYear].totalValueAvgCount += (data.totalValue / data.areaCount)
            hashMonth[monthYear].totalValueAvgSize += (data.totalValue / data.areaSizeCount)
            if (data.isOutOfDate && hashMonth[monthYear].areaCount.length == 0) {
              hashMonth[monthYear].isOutOfMonth = true
            }
          }
          hashMarket[market.objectId] = hashMonth
        }
    
        let hashAll = {}
        let hashTotalMarket = {}
    
        for (let marketId in hashMarket) {
          let hashMonth = hashMarket[marketId]
          for (let monthYear in hashMonth) {
            let data = hashMonth[monthYear]
            let sumAreaCount = data.areaCount.reduce((a, b) => a + b, 0)
            let sumAreaSizeCount = data.areaSizeCount.reduce((a, b) => a + b, 0)
            let sumAreaOccupied = data.areaOccupied.reduce((a, b) => a + b, 0)
            let sumAreaSizeOccupied = data.areaSizeOccupied.reduce((a, b) => a + b, 0)
            hashMarket[marketId][monthYear] = {
              isOutOfMonth: data.isOutOfMonth || false,
              areaCount: (sumAreaCount / data.areaCount.length) || 0,
              areaOccupied: (sumAreaOccupied / data.areaOccupied.length) || 0,
              areaSizeCount: (sumAreaSizeCount / data.areaSizeCount.length) || 0,
              areaSizeOccupied: (sumAreaSizeOccupied / data.areaSizeOccupied.length) || 0,
              areaOccupiedPercent: ((sumAreaOccupied / sumAreaCount) * 100) || 0,
              areaSizeOccupiedPercent: ((sumAreaSizeOccupied / sumAreaSizeCount) * 100) || 0,
              totalValue: data.totalValue || 0,
              totalValueAvgCount: data.totalValueAvgCount || 0,
              totalValueAvgSize: data.totalValueAvgSize || 0,
              totalIncomeValueAvgDay: (data.totalValue / days) || 0,
            }
      
            if (!hashTotalMarket[marketId]) {
              hashTotalMarket[marketId] = {
                areaCount: 0,
                areaOccupied: 0,
                areaSizeCount: 0,
                areaSizeOccupied: 0,
                areaOccupiedPercent: 0,
                areaSizeOccupiedPercent: 0,
                totalValue: 0,
                totalValueAvgCount: 0,
                totalValueAvgSize: 0,
                totalIncomeValueAvgDay: 0
              }
            }
            hashTotalMarket[marketId].areaCount += hashMarket[marketId][monthYear].areaCount
            hashTotalMarket[marketId].areaOccupied += hashMarket[marketId][monthYear].areaOccupied
            hashTotalMarket[marketId].areaSizeCount += hashMarket[marketId][monthYear].areaSizeCount
            hashTotalMarket[marketId].areaSizeOccupied += hashMarket[marketId][monthYear].areaSizeOccupied
            hashTotalMarket[marketId].totalValue += hashMarket[marketId][monthYear].totalValue
            hashTotalMarket[marketId].totalValueAvgCount += hashMarket[marketId][monthYear].totalValueAvgCount
            hashTotalMarket[marketId].totalValueAvgSize += hashMarket[marketId][monthYear].totalValueAvgSize
            hashTotalMarket[marketId].totalIncomeValueAvgDay += hashMarket[marketId][monthYear].totalIncomeValueAvgDay
      
            if (!hashAll[monthYear]) {
              hashAll[monthYear] = {
                areaCount: 0,
                areaOccupied: 0,
                areaSizeCount: 0,
                areaSizeOccupied: 0,
                areaOccupiedPercent: 0,
                areaSizeOccupiedPercent: 0,
                totalValue: 0,
                totalValueAvgCount: 0,
                totalValueAvgSize: 0,
                totalIncomeValueAvgDay: 0
              }
            }
            hashAll[monthYear].isOutOfMonth = hashMarket[marketId][monthYear].isOutOfMonth
            hashAll[monthYear].areaCount += hashMarket[marketId][monthYear].areaCount
            hashAll[monthYear].areaOccupied += hashMarket[marketId][monthYear].areaOccupied
            hashAll[monthYear].areaSizeCount += hashMarket[marketId][monthYear].areaSizeCount
            hashAll[monthYear].areaSizeOccupied += hashMarket[marketId][monthYear].areaSizeOccupied
            hashAll[monthYear].totalValue += hashMarket[marketId][monthYear].totalValue
            hashAll[monthYear].totalIncomeValueAvgDay += hashMarket[marketId][monthYear].totalIncomeValueAvgDay
          }
          for (let productCategoryId in productData.hashMarket[marketId]) {
            productData.hashMarket[marketId][productCategoryId].count = productData.hashMarket[marketId][productCategoryId].areas.length
            delete productData.hashMarket[marketId][productCategoryId].areas
          }
        }

        for (let productCategoryId in productData.hashAll) {
          productData.hashAll[productCategoryId].count = productData.hashAll[productCategoryId].areas.length
          delete productData.hashAll[productCategoryId].areas
        }

        let customerRanking = Object.entries(hashCustomer)
          .map(([key, value]) => ({ name: key, data: value.data, totalValue: value.totalValue }))
          .sort((a, b) => b.totalValue - a.totalValue)
          .slice(0, 20);
      
        for (let key in hashTotalMarket) {
          let data = hashTotalMarket[key]
          hashTotalMarket[key].areaOccupiedPercent = (data.areaOccupied / data.areaCount * 100) || 0,
          hashTotalMarket[key].areaSizeOccupiedPercent = (data.areaSizeOccupied / data.areaSizeCount * 100) || 0
          delete hashTotalMarket[key].areaOccupiedPercentList
          delete hashTotalMarket[key].areaSizeOccupiedPercentList
        }
      
        for (let key in hashAll) {
          let data = hashAll[key]
          hashAll[key].areaOccupiedPercent = (data.areaOccupied / data.areaCount * 100) || 0,
          hashAll[key].areaSizeOccupiedPercent = (data.areaSizeOccupied / data.areaSizeCount * 100) || 0
          hashAll[key].totalValueAvgCount = (hashAll[key].totalValue / hashAll[key].areaCount) || 0
          hashAll[key].totalValueAvgSize = (hashAll[key].totalValue / hashAll[key].areaSizeCount) || 0
          delete hashAll[key].areaOccupiedPercentList
          delete hashAll[key].areaSizeOccupiedPercentList
        }
    
        let rentalAreaOccupiedPercentList = []
        let rentalAreaSizeOccupiedPercentList = []
        let totalIncomeValue = 0
        let totalIncomeValueAvgSize = 0
        let totalIncomeValueAvgCount = 0
    
        for (let key in hashAll){
          let data = hashAll[key]
          rentalAreaOccupiedPercentList.push(data.areaOccupiedPercent)
          rentalAreaSizeOccupiedPercentList.push(data.areaSizeOccupiedPercent)
          totalIncomeValue += data.totalValue
          totalIncomeValueAvgCount += data.totalValueAvgCount
          totalIncomeValueAvgSize += data.totalValueAvgSize
        }
        
        let result = {
          startDate: payload.startDate,
          endDate: payload.endDate,
          rentalRate: {
            markets: hashMarket,
            all: hashAll,
            totalMarket: hashTotalMarket
          },
          income: {
            markets: hashMarket,
            all: hashAll,
            totalMarket: hashTotalMarket
          },
          area: hasArea,
          accountingProduct: {
            markets: accData.hashMarket,
            all: accData.hashAll
          },
          product: {
            markets: productData.hashMarket,
            all: productData.hashAll
          },
          customerRanking: customerRanking,
          rentalAreaOccupiedPercent: rentalAreaOccupiedPercentList.reduce((a, b) => a + b, 0) / rentalAreaOccupiedPercentList.length,
          rentalAreaSizeOccupiedPercent: rentalAreaSizeOccupiedPercentList.reduce((a, b) => a + b, 0) / rentalAreaSizeOccupiedPercentList.length,
          totalIncomeValue,
          totalIncomeValueAvgDay: totalIncomeValue / days,
          totalIncomeValueAvgSize,
          totalIncomeValueAvgCount,
        }
        
        return result
      } catch (error) {
        throw error
      }
    }
  },
  getters: {

  },
};
export default OverallModule;
